import { createDemo } from '@mui/internal-core-docs/utils/createDemo';
import CustomInputAutocomplete from './CustomInputAutocomplete';
import ClientProvider from './client';
export default createDemo(import.meta.url, CustomInputAutocomplete, { ClientProvider, precompute: {
  "Default": {
    "url": "file:///opt/build/repo/docs/data/material/components/autocomplete/demos/custom-input/CustomInputAutocomplete.tsx",
    "fileName": "CustomInputAutocomplete.tsx",
    "language": "tsx",
    "source": {
      "type": "root",
      "children": [
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "import Autocomplete from '@mui/material/Autocomplete';\n\nconst options = ['Option 1', 'Option 2'];\n\nexport default function CustomInputAutocomplete() {\n  return (\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "dataFrameType": "focus-unfocused",
            "dataFrameIndent": 2,
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "    <label>\n      Value:{' '}\n      <Autocomplete\n        sx={(theme) => ({\n          display: 'inline-block',\n          '& input': {\n            width: 200,\n            bgcolor: 'background.paper',\n            color: theme.palette.getContrastText(theme.palette.background.paper),\n          },\n        })}\n        id=\"custom-input-demo\"\n        options={options}\n        renderInput={(params) => (\n          <div ref={params.slotProps.input.ref}>\n            <input type=\"text\" {...params.slotProps.htmlInput} />\n          </div>\n        )}\n      />\n    </label>\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "  );\n}\n"
            }
          ]
        }
      ],
      "data": {
        "totalLines": 28,
        "focusedLines": 0,
        "collapsible": true
      }
    },
    "fallback": [
      [
        "span",
        "frame",
        "import Autocomplete from '@mui/material/Autocomplete';\n\nconst options = ['Option 1', 'Option 2'];\n\nexport default function CustomInputAutocomplete() {\n  return (\n"
      ],
      [
        "span",
        "frame",
        {
          "dataFrameType": "focus-unfocused",
          "dataFrameIndent": 2
        },
        "    <label>\n      Value:{' '}\n      <Autocomplete\n        sx={(theme) => ({\n          display: 'inline-block',\n          '& input': {\n            width: 200,\n            bgcolor: 'background.paper',\n            color: theme.palette.getContrastText(theme.palette.background.paper),\n          },\n        })}\n        id=\"custom-input-demo\"\n        options={options}\n        renderInput={(params) => (\n          <div ref={params.slotProps.input.ref}>\n            <input type=\"text\" {...params.slotProps.htmlInput} />\n          </div>\n        )}\n      />\n    </label>\n"
      ],
      [
        "span",
        "frame",
        "  );\n}\n"
      ]
    ],
    "totalLines": 28,
    "focusedLines": 0,
    "collapsible": true,
    "externals": [
      "@mui/material/Autocomplete"
    ]
  }
}, loadPrecompute: () => import("./index.ts?mui-deferred-precompute").then((module) => module.default) });
